import { render } from "./ReConfigMFAComponent.vue?vue&type=template&id=005723a6&scoped=true"
import script from "./ReConfigMFAComponent.vue?vue&type=script&lang=js"
export * from "./ReConfigMFAComponent.vue?vue&type=script&lang=js"

import "./ReConfigMFAComponent.vue?vue&type=style&index=0&id=005723a6&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-005723a6"]])

export default __exports__